import { AlertTriangle } from 'lucide-react-native';
import { StyleSheet, View } from 'react-native';

import { colors, spacing } from '@/constants/theme';

import { Button } from './Button';
import { Card } from './Card';
import { Heading } from './Heading';
import { Text } from './Text';

export type ErrorStateProps = {
  title?: string;
  body?: string;
  onRetry?: () => void;
  retryLabel?: string;
  /** Render without a Card wrapper for inline placement. */
  bare?: boolean;
  testID?: string;
};

export function ErrorState({
  title = 'Something went wrong',
  body = "Couldn't load. Try again.",
  onRetry,
  retryLabel = 'Try again',
  bare = false,
  testID,
}: ErrorStateProps) {
  const inner = (
    <>
      <AlertTriangle size={32} color={colors.deepGreen} strokeWidth={1.75} />
      <Heading size="2xl" style={styles.title}>
        {title}
      </Heading>
      <Text variant="caption" color="textMuted" align="center" style={styles.body}>
        {body}
      </Text>
      {onRetry && (
        <Button label={retryLabel} variant="primary" size="sm" onPress={onRetry} />
      )}
    </>
  );

  if (bare) {
    return (
      <View style={styles.container} testID={testID}>
        {inner}
      </View>
    );
  }

  return (
    <Card style={styles.container} testID={testID}>
      {inner}
    </Card>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingVertical: spacing.xl,
    gap: spacing.sm,
  },
  title: {
    color: colors.danger,
    textAlign: 'center',
  },
  body: {
    maxWidth: 280,
  },
});
